const ADD_CONGRESS = "ADD_CONGRESS";
const REMOVE_CONGRESS = "REMOVE_CONGRESS";
const SET_CONGRESS = "SET_CONGRESS";

export const addNewCongress = (payload) => {
    return {
        type: ADD_CONGRESS,
        payload,
    };
};
export const setDermariseCongress = (payload) => {
    return {
        type: SET_CONGRESS,
        payload,
    };
};
export const removeCongress = (payload) => {
    return {
        type: REMOVE_CONGRESS,
        payload,
    };
};

const initialState = {
    congress: undefined,
};
export default (state = initialState, action) => {
    // console.log(payload)
    switch (action.type) {
        case ADD_CONGRESS:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }

            // console.log('ihuguguh',state.congress.nodes.find(c=> c.congressPath === action.payload.congressPath));
            if (!state.congress.nodes.find((c) => c.congressPath === action.payload.congressPath)) {
                state.congress.nodes = state.congress.nodes.concat(action.payload);
            }
            return {
                ...state,
            };

        case REMOVE_CONGRESS:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            } else {
                // console.log("path"+action.payload)
                const index = state.congress.nodes.findIndex(
                    (value) => value.congressPath === action.payload
                );
                // console.log("ididid"+index)
                state.congress.nodes = state.congress.nodes.slice(0, index);
                return {
                    ...state,
                };
            }
        case SET_CONGRESS:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            return {
                ...state,
                congress: {
                    ...state.congress,
                    ...action.payload,
                },
            };

        default:
            return state;
    }
};
